// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".BlackFridayScrollTop{display:flex;align-items:center;justify-content:center;position:fixed;width:40px;height:40px;background:rgba(219,41,128,0.76);bottom:81px;right:0px;cursor:pointer;z-index:1}@media (min-width: 1024px){.BlackFridayScrollTop{width:70px;height:70px;bottom:40px;right:40px}}.BlackFridayScrollTop svg{height:20px}@media (min-width: 1024px){.BlackFridayScrollTop svg{height:auto}}.BlackFridayScrollTop:hover{background:#db2980}\n", ""]);
// Exports
module.exports = exports;
